import { useContext, useState, useEffect } from 'react';
import { Input, Text } from '@postenbring/hedwig-react'
import { InputsContext } from "../../InputsContext";

const FULL_POSTALCODE_PATTERN = /^\d{4}$/
const validatePostalCode = (code) => FULL_POSTALCODE_PATTERN.test(code)

const getPostalCodeErrorMessage = (labels, currentPostalCode, fieldId, apiInvalidArgFields) => {
    if (currentPostalCode != null) {
        if (!validatePostalCode(currentPostalCode)) {
            return labels.postalErrorMessage
        }
        if (apiInvalidArgFields && apiInvalidArgFields.indexOf(fieldId) !== -1) {
            return labels.invalidPostalCode
        }
    }
    return null
}

// Group up to 4 digits at the start of the string, capture and return that, trash any non-digit chars or digits after the first 4:
const PARTIAL_POSTALCODE_PATTERN = /^(\d{1,4}).*$/
const extractPostalCodeAtStart = (input) => ( input.match(PARTIAL_POSTALCODE_PATTERN) || [] )[1] || ""


export const PostalCodeInput = ({ 
    label, 
    postalCode, 
    setPostalCode, 
    currentPostalCode, 
    labels, 
    fieldId,
    externalErrorMessage
    }) => {
    const { 
        apiInvalidArgFields
    } = useContext(InputsContext)
    const [touched, setTouched] = useState(false)
    const [city, setCity] = useState("");

    const changePostalCode = (e) => {
        const inputPostalCode = e.target.value
        const postalCode = extractPostalCodeAtStart(inputPostalCode)
        setPostalCode(postalCode)
    }

    useEffect(() => {
        if (validatePostalCode(postalCode)) {
            let isCurrent = true; // This flag is unique to this effect run
            fetch(`https://adressesok.posten.no/api/v1/addresses.json?address=postnummer:${postalCode}`)
                .then(res => res.json())
                .then(data => {
                    if (isCurrent) { // Only update if this is the latest fetch
                        const place = data.addresses?.[0]?.city || labels.unknownPostalCode;
                        setCity(place)
                    }
                })
                .catch(() => {
                    if (isCurrent) setCity("")
                });
            return () => { isCurrent = false; } // Cleanup: mark this fetch as obsolete if postalCode changes
        } else {
            setCity("")
        }
    }, [postalCode, labels.unknownPostalCode])

    const handleBlur = () => {
        setTouched(true)
    }

    const internalError = touched
        ? getPostalCodeErrorMessage(labels, currentPostalCode, fieldId, apiInvalidArgFields)
        : null

    const errorMessage = externalErrorMessage || internalError

    return (
        <div>
            <Input
                label={label}
                onChange={changePostalCode}
                onBlur={handleBlur}
                value={postalCode || ""}
                type="text"
                inputMode="numeric"
                placeholder={labels.digits4}
                errorMessage={errorMessage}
                maxLength='4'
            />
            {city && (
                <Text className="hds-mt-8">
                    {city}
                </Text>
            )}
        </div>
    )
}
